import { useTranslation } from 'react-i18next';
import { Box, Flex, Stack } from '../../../shared/layouts';
import RadioButtonBlocks from '../components/RadioButtonBlocks';
import {
  formatAppointmentDate,
} from '../../../../utils/dateHelpers';
import moment from 'moment/moment';
import { Fragment } from 'react';
import Button from '../../../shared/Button';
import useIconLibrary from '../../../../hooks/useIconLibrary';

const QuickDatePicker = ({
  start_date,
  availability,
  setUseSpecific,
  handleChangeAppointment,
}) => {
  const { t } = useTranslation();
  const { CalendarIcon } = useIconLibrary();
  const {
    day: setDay = '',
    time: setTime = '',
  } = formatAppointmentDate(start_date);

  const firstFewDates = availability?.dates.slice(0, 3);

  return (
    <Stack space={'l'}>
      <Box fontWeight={'bold'} fontScale={'l'}>
        {t('Beschikbare tijden')}
      </Box>
      {firstFewDates.length > 0 && firstFewDates.map(date => {
          const readableDate = moment(date, 'YYYY-MM-DD', 'nl', true).format(
            'dddd, D MMMM'
          );
          const { day: optionDay = '' } = formatAppointmentDate(date);

          return (
            <Fragment key={date}>
              <RadioButtonBlocks
                label={readableDate}
                name={date}
                value={setDay === optionDay ? setTime : null}
                onChange={value => {
                  const newDate = `${date} ${value}`;
                  return handleChangeAppointment({
                    target: { name: 'start_date', value: newDate }
                  });
                }}
                options={(availability?.timesByDate[date] || []).map(t => t.slice(0, -3))}
                switchToSpecific={(date) => {
                  const newDate = `${date}`;
                  setUseSpecific(true);
                  return handleChangeAppointment({
                    target: { name: 'start_date', value: newDate }
                  });
                }}
                showSummarized
              />
            </Fragment>
          );
        })}
      <Button
        variant={'anchor'}
        css={{ padding: 0 }}
        onClick={() => setUseSpecific(value => !value)}
      >
        <Flex alignItems={'center'}>
          <CalendarIcon
            width={'2rem'}
            height={'2rem'}
            css={({ colors, space }) => ({
              marginRight: space.s,
              fill: colors?.secondary
            })}
          />
          {t('Alle beschikbare tijden')}
        </Flex>
      </Button>
    </Stack>
  );
};

export default QuickDatePicker;
